import React, { useState } from 'react';

interface ConfigureStepProps {
  onNext: (did: string) => void;
  onCancel: () => void;
}

const ConfigureStep: React.FC<ConfigureStepProps> = ({ onNext, onCancel }) => {
  const [did, setDid] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!did.trim()) {
      newErrors.did = 'MPX Control Plane DID is required';
    } else if (!did.trim().startsWith('did:')) {
      newErrors.did = 'DID must start with "did:"';
    } else {
      // Basic DID format validation
      const didRegex = /^did:[a-z0-9]+:[a-zA-Z0-9._:%-]+$/;
      if (!didRegex.test(did.trim())) {
        newErrors.did = 'Invalid DID format';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onNext(did.trim());
    }
  };

  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="welcome-screen">
          <h2>MPX Control Plane DID</h2>
          <p>
            Enter the Decentralized Identifier (DID) of your Meeting Place (MPX) Control Plane. 
            We'll resolve this DID to discover the API endpoint and verify the connection.
          </p>

          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div className="mb-4">
              <label htmlFor="did" className="form-label">
                <strong>MPX Control Plane DID *</strong>
              </label>
              <input
                type="text"
                className={`form-control ${errors.did ? 'is-invalid' : ''}`}
                id="did"
                value={did}
                onChange={(e) => setDid(e.target.value)}
                placeholder="did:web:mpx.example.com"
                autoFocus
              />
              {errors.did && (
                <div className="invalid-feedback">{errors.did}</div>
              )}
              <small className="form-text text-muted">
                The DID will be resolved to discover the MPX API endpoint
              </small>
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                <i className="fas fa-times mr-2"></i>
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
              >
                Next <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConfigureStep;
